module.exports = __webpack_public_path__ + "static/data_bar_8-35c9b8fff966237dc2dcbba83fda5843.png";